import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body2_b14,
  Noto_body2_r14,
  Noto_subheading_r18,
} from 'src/styles/fonts/NotoSansKrFonts'
import styled from 'styled-components'
import Button, { ButtonOption3 } from 'src/components/common/Button'
import { layoutMaxSize } from 'src/styles/mixin'
import { PaymentFinishPageProps } from 'src/pages/PaymentFinishPage/index'
import icon_noti from 'src/assets/images/purchase/purchase_notice_icon.png'

const textLogo = `${process.env.PUBLIC_URL}/images/text_logo.svg`

const PaymentFinishPageView = ({ handleCloseButton, isHotDeal }: PaymentFinishPageProps) => {
  return (
    <S.PaymentFinishContainer $option="flex_column">
      <S.PaymentFinishHeader $option="flex_column">
        <S.HeaderLogoImage src={textLogo} alt="logo" />
      </S.PaymentFinishHeader>
      <S.PaymentFinishContents $option="flex_column" $row_gap="50px">
        <S.PaymentFinishTextWrap $option="flex_column">
          <Typography $fontStyle={Noto_subheading_r18} $color="var(--black-80)">
            주문하신 앱/웹브라우저로 이동하면
            <br />
            결제가 완료됩니다.
          </Typography>
          {isHotDeal && (
            <S.PurchaseNoticeContainer $option="flex_column" $row_gap="10px">
              <img src={icon_noti} alt="purchase_notice_icon" width={40} height={40} />
              <Container $option="flex_column" $row_gap="6px">
                <Typography $fontStyle={Noto_body2_r14} $color="var(--black-60)">
                  핫딜 쿠폰의 영리 목적 재판매는 이용약관에 따라 제한됩니다.
                </Typography>
                <Typography $fontStyle={Noto_body2_b14} $color="var(--black-60)">
                  동일 일자의 유사 시간대에
                  <br />
                  서로 다른 지역에서 사용된 정황이
                  <br />
                  반복 확인될 경우,
                  <br />
                  <strong>핫딜 쿠폰 구매가 제한</strong>됩니다.
                </Typography>
              </Container>
            </S.PurchaseNoticeContainer>
          )}
        </S.PaymentFinishTextWrap>
        <S.PaymentFinishButtonWrap>
          <Button option={ButtonOption3('active')} onClickFn={handleCloseButton}>
            이동하기
          </Button>
        </S.PaymentFinishButtonWrap>
      </S.PaymentFinishContents>
    </S.PaymentFinishContainer>
  )
}
export default PaymentFinishPageView
const S = {
  PaymentFinishContainer: styled(Container)`
    ${layoutMaxSize};
    background-color: var(--black-4);
    margin: 0 auto;
    overflow: auto;
    min-height: calc(var(--vh, 1vh) * 100);
    height: 100%;
    align-items: center;
  `,
  PaymentFinishHeader: styled(Container)`
    justify-content: center;
    height: 50px;
    background-color: var(--white);
    border-bottom: 1px solid var(--black-6);
  `,
  HeaderLogoImage: styled.img`
    height: 38px;
  `,
  PaymentFinishContents: styled(Container)`
    flex: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: 0 auto;
    padding: 50px 20px;
    word-break: keep-all;
  `,

  PaymentFinishTextWrap: styled(Container)`
    flex: 1;
    justify-content: center;
    max-width: 320px;

    & > span {
      display: flex;
      justify-content: center;
      align-items: center;
      height: calc(100vh - 248px - 248px); /* 공백:248px, 구매제한 안내 높이:248px */
      max-height: 300px;
    }
  `,
  PurchaseNoticeContainer: styled(Container)`
    align-items: center;
    padding: 24px 30px;
    background-color: var(--white);
    border-radius: 14px;

    strong {
      color: var(--red-30);
    }
  `,
  PaymentFinishButtonWrap: styled(Container)``,
}
